import React from 'react';
import { Basic } from './Info/Basic';

// Import components
import InfoAboveTitle from './InfoAboveTitle';
import Title from './Title';
import SummaryShort from './SummaryShort';
import InfoTabButtons from './InfoTabButtons/InfoTabButtons';
import Details from './Details';
import DescriptionSection from './DescriptionSection';
import SubInformations from './SubInformations';
import TabInfo from './TabInfo/TabInfo';

const SeriesInfo = () => {
	return (
		<>
			<InfoAboveTitle />

			<Title />

			<Basic />

			<InfoTabButtons />

			<TabInfo />

			<SummaryShort />

			<Details />

			<DescriptionSection />

			<SubInformations />
		</>
	);
};

export default SeriesInfo;
